// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-main {
  padding: 20px;
  color: #333;
  margin: 50px 0;
}

.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-section {
  display: flex;
  justify-content: space-around;
  width: 100%;
  max-width: 1200px;
}

.footer-leftsec {
  flex: 1 1;
  min-width: 300px;
  margin-right: 50px;
}

.footer-leftsec img {
  margin-bottom: 30px !important;
}
.footer-leftsec p {
  font-family: inter !important;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
}
.footer_social_icons {
  margin-bottom: 30px !important;
}

.footer-links {
  display: flex;
  margin-right: 50px;
  flex-direction: column;
}

.footer-links a {
  text-decoration: none;
  font-family: "Poppins", sans-serif !important;
  color: #333;
  margin: 5px 0;
}

.footer-social-icons {
  display: flex;
  margin-top: 20px;
}

.footer-social-icons a {
  margin: 0 10px;
}

.footer_icon {
  width: 35px;
  height: 35px;
  padding: 10px;
  gap: 0px;
  border-radius: 50px;
  margin-right: 10px;
  background-color: #222530;
  color: white !important;
}

.footer-contact {
  flex: 1 1;
  min-width: 200px;
}

h5 {
  margin-bottom: 10px;
  font-family: "Poppins", sans-serif !important;
}

.footer-contact p,
.footer-leftsec p {
  line-height: 1.5;
  font-family: inter !important;
}

.footer-links h5 {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
}

.footer-copyright{
  align-items: center;
  justify-content: center;
  display: flex;
  width: Fill (1,200px)px;
height: Hug (39px)px;
padding: 8px 18px 8px 18px;
gap: 8px;
border-radius: 10px;
background-color: #F5F7FA;

}

.footer-copyright h4{
  font-family: Inter;
  color: #717784;
font-size: 13.7px;
font-weight: 400;
line-height: 22.5px;
text-align: center;

}

@media (max-width: 768px) {
  .footer-leftsec,
  .footer-links,
  .footer-contact {
    align-items: flex-start; /* Align items to the left */
  }

  .footer-leftsec img {
    margin-bottom: 30px !important;
  }

  .footer-leftsec p,
  .footer-contact p {
    margin-bottom: 30px !important;
    text-align: left; /* Text align left */
  }

  .footer_social_icons {
    margin-bottom: 30px !important;
    justify-content: flex-start; /* Align social icons to the left */
  }

  .footer-section {
    flex-direction: column;
    align-items: flex-start; /* Align entire sections to the left */
  }

  .footer-links {
    margin-bottom: 50px !important;
  }

  .footer-links a {
    text-align: left; /* Ensures links are aligned left */
  }

  .footer-icon {
    align-self: flex-start; /* Aligns icons within links to the left */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Footer/footertwo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;;EAEE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB,oBAAoB;AACpB,0BAA0B;AAC1B,QAAQ;AACR,mBAAmB;AACnB,yBAAyB;;AAEzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB,iBAAiB;AACjB,gBAAgB;AAChB,mBAAmB;AACnB,kBAAkB;;AAElB;;AAEA;EACE;;;IAGE,uBAAuB,EAAE,4BAA4B;EACvD;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,8BAA8B;IAC9B,gBAAgB,EAAE,oBAAoB;EACxC;;EAEA;IACE,8BAA8B;IAC9B,2BAA2B,EAAE,mCAAmC;EAClE;;EAEA;IACE,sBAAsB;IACtB,uBAAuB,EAAE,sCAAsC;EACjE;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB,EAAE,mCAAmC;EACvD;;EAEA;IACE,sBAAsB,EAAE,0CAA0C;EACpE;AACF","sourcesContent":[".footer-main {\n  padding: 20px;\n  color: #333;\n  margin: 50px 0;\n}\n\n.footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.footer-section {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  max-width: 1200px;\n}\n\n.footer-leftsec {\n  flex: 1;\n  min-width: 300px;\n  margin-right: 50px;\n}\n\n.footer-leftsec img {\n  margin-bottom: 30px !important;\n}\n.footer-leftsec p {\n  font-family: inter !important;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  text-align: left;\n}\n.footer_social_icons {\n  margin-bottom: 30px !important;\n}\n\n.footer-links {\n  display: flex;\n  margin-right: 50px;\n  flex-direction: column;\n}\n\n.footer-links a {\n  text-decoration: none;\n  font-family: \"Poppins\", sans-serif !important;\n  color: #333;\n  margin: 5px 0;\n}\n\n.footer-social-icons {\n  display: flex;\n  margin-top: 20px;\n}\n\n.footer-social-icons a {\n  margin: 0 10px;\n}\n\n.footer_icon {\n  width: 35px;\n  height: 35px;\n  padding: 10px;\n  gap: 0px;\n  border-radius: 50px;\n  margin-right: 10px;\n  background-color: #222530;\n  color: white !important;\n}\n\n.footer-contact {\n  flex: 1;\n  min-width: 200px;\n}\n\nh5 {\n  margin-bottom: 10px;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.footer-contact p,\n.footer-leftsec p {\n  line-height: 1.5;\n  font-family: inter !important;\n}\n\n.footer-links h5 {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  text-align: left;\n}\n\n.footer-copyright{\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  width: Fill (1,200px)px;\nheight: Hug (39px)px;\npadding: 8px 18px 8px 18px;\ngap: 8px;\nborder-radius: 10px;\nbackground-color: #F5F7FA;\n\n}\n\n.footer-copyright h4{\n  font-family: Inter;\n  color: #717784;\nfont-size: 13.7px;\nfont-weight: 400;\nline-height: 22.5px;\ntext-align: center;\n\n}\n\n@media (max-width: 768px) {\n  .footer-leftsec,\n  .footer-links,\n  .footer-contact {\n    align-items: flex-start; /* Align items to the left */\n  }\n\n  .footer-leftsec img {\n    margin-bottom: 30px !important;\n  }\n\n  .footer-leftsec p,\n  .footer-contact p {\n    margin-bottom: 30px !important;\n    text-align: left; /* Text align left */\n  }\n\n  .footer_social_icons {\n    margin-bottom: 30px !important;\n    justify-content: flex-start; /* Align social icons to the left */\n  }\n\n  .footer-section {\n    flex-direction: column;\n    align-items: flex-start; /* Align entire sections to the left */\n  }\n\n  .footer-links {\n    margin-bottom: 50px !important;\n  }\n\n  .footer-links a {\n    text-align: left; /* Ensures links are aligned left */\n  }\n\n  .footer-icon {\n    align-self: flex-start; /* Aligns icons within links to the left */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
